var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgViewIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5516 26.3046C6.57798 26.3046 0.924805 20.5432 0.924805 13.4361C0.924805 6.32897 6.57798 0.567535 13.5516 0.567535C20.5251 0.567535 26.1783 6.32897 26.1783 13.4361C26.1783 20.5432 20.5251 26.3046 13.5516 26.3046ZM11.6575 11.7632V20.2564C11.6575 21.323 12.5056 22.1867 13.5516 22.1867C14.5954 22.1867 15.4456 21.3226 15.4456 20.2564V11.7632C15.4456 10.6966 14.5976 9.83289 13.5516 9.83289C12.5077 9.83289 11.6575 10.697 11.6575 11.7632ZM13.5516 8.54604C14.5976 8.54604 15.4456 7.68178 15.4456 6.61575C15.4456 5.54955 14.5976 4.68547 13.5516 4.68547C12.5056 4.68547 11.6575 5.54955 11.6575 6.61575C11.6575 7.68178 12.5056 8.54604 13.5516 8.54604Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgViewIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ViewIcon.db1f5f5d.svg";
export { ForwardRef as ReactComponent };